import { computed } from 'vue'
import useUserStore from '@/stores/modules/user'

export default function userInfo() {
    const userStore = useUserStore()

    // 是否为普通用户
    const isDomesticConsumer = computed(() => {
        return userStore.isDomesticConsumer
    })

    const userInfo = computed(() => {
        return userStore.userInfo
    })

    return {
        isDomesticConsumer,
        userInfo
    }
}
